import React from 'react'
import { Popup, Icon, Image } from 'semantic-ui-react'
import _ from 'lodash';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import contentIcon from "../../../../../images/svg/noti-content.svg";
import diamond from "../../../../../images/grafix-icon/diamond.svg";
class PlaybookActivityCard extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            propsRecieved:true
        }
    }
    componentWillReceiveProps(nextProps){
        this.setState({propsRecieved:!this.state.propsRecieved})
    }

     isWorkspaceOwner = () => {
        let authors =
          this.props.currentOrganization &&
          this.props.currentOrganization.users &&
          this.props.currentOrganization.users.filter(
            (el) =>
              el.accountUserId === this.props.user._id &&
              el.role === "workspaceOwner"
          );
        if (authors && authors.length > 0) {
          return true;
        }
        return null;
      };

     isManager = () => {
        let manager =
          this.props.currentOrganization &&
          this.props.currentOrganization.users &&
          this.props.currentOrganization.users.filter(
            (el) =>
              el.accountUserId === this.props.user._id &&
              el.role === "Manager"
          );
        if (manager && manager.length > 0) {
          return true;
        }
        return null;
      };

    isAuthor = () => {
        let loggdinUserId;
        if (this.props.user && this.props.user.email) {
            loggdinUserId = this.props.user.email;
        }
        let author =
            this.props.selectedPracticeLibrary &&
            this.props.selectedPracticeLibrary.participants &&
            this.props.selectedPracticeLibrary.participants.filter((participant) => {
                return participant.role === "author";
            });
        if (author && author.length > 0) {
            return author.some((author) => author.email === loggdinUserId);
        }
        return false;
    };



    handleCardClick = async (e, card, type) => { 
        e.stopPropagation();
        this.setState({ selectedType: type })
        let actId = card.objectId ? card.objectId : card._id;

        if (this.props.page === "assign" && (this.props.type === "phase" || this.props.type === "stage")) {
            await dispatch.createPack.getSelectedCommunityAsync(actId);
            await dispatch.lifeCycle.showResourecePane("CommunityFlow")
            await dispatch.createPack.setSelectedActivityData({});

        } else {
            await dispatch.createPack.getSelectedActivityAsync(actId);;
            dispatch.lifeCycle.showResourecePane("PracticeCommunitySwimLineCommanPane");
            await dispatch.createPack.setSelectedCommunityData({});
        }

        dispatch.lifeCycle.enableLinking();
        await dispatch.lifeCycle.setIdToCenterPosition(actId)

        //Activity click
        // const { onCardClick } = this.props;
        // onCardClick && onCardClick(card.id, card.metadata, card.laneId)


        dispatch.createPack.activityUniqueIdSet(actId);

        if (this.props.collapsedResourcePaneIndexTemp == null) {
            dispatch.lifeCycle.splitAt("60%");
        }
        dispatch.createPack.showDuplicateIcon(true);
    }

    removeCard = async (e, activityData) => {
        e.stopPropagation();
        let message = <div className="confirmMessage">
            <h3>Delete Activity</h3>
            <label>{activityData.name}</label>
            <p>Are you sure that you wish to do this?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: async () => {
                try {
                    await dispatch.lifeCycle.deleteActivity({ packId: this.props.selectedPracticeLibrary._id, id: activityData._id });
                    dispatch.app.setCollapsedResourcePaneIndexTemp(null)
                    dispatch.lifeCycle.showResourecePane(null);
                }
                catch (err) {
                    dispatch.lifeCycle.setError(err);
                }
            }
        });
    }

    doubleClickOnActivity = (e, card) => {
        // dispatch.lifeCycle.showResourecePane("PracticeCommunitySwimLineCommanPane")
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.lifeCycle.splitAt("60%");
    };

    getMapping(id) {
        if (this.props.communities)
            for (let i = 0; i < this.props.communities.length; i++) {
                let community = this.props.communities[i];
                if (id === community._id) {
                    return community.name;
                }
                if (community.communities) {
                    for (let j = 0; j < community.communities.length; j++) {
                        let subCommunity = community.communities[j];
                        if (id === subCommunity._id) {
                            return community.name + " > " + subCommunity.name;
                        }
                    }
                }
            }
    }

    dependencyClick = (e, card) => {
        e.stopPropagation();
        let activityId = this.props.activityData._id ? this.props.activityData._id : this.props.activityData.objectId
        if (this.props.enableLinkActivity) {
            if (this.props.selectedActivity._id !== activityId) {
                let dependencyIndex = this.props.selectedActivity.dependencies.indexOf(activityId);
                if (dependencyIndex === -1) {
                    this.props.selectedActivity.dependencies.push(activityId);
                    // this.props.addEdge(this.props.selectedActivity._id.toString(), activityId.toString());
                    dispatch.createPack.editActivityAsync(this.props.selectedActivity);
                }
                else {
                    let message = <div className="confirmMessage">
                        <h3>Delete Dependency</h3>
                        <p>Are you sure that you wish to do this?</p>
                        <span >This action is not reversible</span>
                    </div>
                    toastr.confirm(message, {
                        onOk: () => {
                            if (dependencyIndex !== -1) {
                                this.props.selectedActivity.dependencies.splice(dependencyIndex, 1)
                                this.props.removeEdge(this.props.selectedActivity._id.toString(), activityId.toString());
                                dispatch.createPack.editActivityAsync(this.props.selectedActivity)
                            }
                        }
                    });
                }
            }
        }
    }

    render() {

        const { activityData, selectedActivity, enableLinkActivity, _id, type, page, selectedPracticeLibrary } = this.props;
        let borderColor = activityData.communityTagColor ? activityData.communityTagColor : activityData.tagColor
        if (!_.isEmpty(selectedActivity)) {
            this.setState({ selectedId: selectedActivity._id })
        }
        let activityId = activityData._id ? activityData._id : activityData.objectId
        let checkDependency = selectedActivity && selectedActivity.dependencies && selectedActivity.dependencies.length > 0 && selectedActivity.dependencies.indexOf(_id) != -1
        let communityRACI = (page === "sequence" || page === "assign" && type === 'activity') && activityData && activityData.raci ? <Popup
            content=
            {this.getMapping(activityData.raci.a)}
            inverted
            position="top left"
            className="popupStyled"
            trigger={
                activityData.raci.a ?
                    <div style={{ position: "absolute", width: "4px", left: "-4px", top: "0", height: "100%", background: "transprant" }} >
                    </div>
                    : ''
            }
        /> : null

        const styles = {
            card: {
                borderLeft: "5px solid" + borderColor,
                height: page === "assign" && (type === "phase" || type === "stage") ? "90px" : "90px"
            }
        }
        return (
            <div
                className={`
                playbookActivityCard cursor-pointer 
                ${selectedActivity && selectedActivity._id === activityId ? "activeActivity" : ""} 
                ${checkDependency ? "dependency-bg-color" : ""} 
            `}
                style={styles.card}
                onClick={e => this.handleCardClick(e, activityData, type)}
                onDoubleClick={e => this.doubleClickOnActivity(e, activityData)}
            >
                {communityRACI}
                < div className="activity-head" >
                    <div className={`activity-name ${activityData.lanes && activityData.lanes.length === 1 ? "ph_w_180" : ""} `}>
                        <EllipsisTooltip
                            name={activityData.name}
                            position="top left"
                            line={2}
                        />
                    </div>
                {activityData && activityData.metaData && (activityData.metaData.generateActivitiesInProgress || activityData.metaData.generateActivityDetailsInProgress) && <div className="spinner"></div>}
                </div >
                <div className="activity-footer" >
                {activityData && activityData.aiGenStatus === -1 && (
                    <Popup
                    className="popupStyled"
                    mouseEnterDelay={500}
                    position="top left"
                    inverted
                    content="This activity is not generated by AI"
                    trigger={
                      <span style={{ display: 'flex', alignItems: 'center', minHeight: '20px', float: 'left', padding: '4px', backgroundColor: 'white', borderRadius: '9999px', marginLeft: '2px', marginRight: '3px' }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-circle-alert"
                          style={{ color: 'red', width: '15px', height: '15px' }}
                        >
                          <circle cx="12" cy="12" r="10" />
                          <line x1="12" x2="12" y1="8" y2="12" />
                          <line x1="12" x2="12.01" y1="16" y2="16" />
                        </svg>
                      </span>
                    }
                  />
                    )}
                    {activityData.isMilestone ?
                        <Popup
                            content='Milestone'
                            className="popupStyled"
                            mouseEnterDelay={500}
                            position="top right"
                            inverted
                            trigger={<div className="activity-circle-icon " >
                                <img src={diamond} name="diamond" alt='Milestone' style={{ margin: "4px" }} />
                            </div>} />
                        : null
                    }
                    {this.props.currentOrganization && 
                        Array.isArray(this.props.currentOrganization.integrations) &&
                        this.props.type === "activity" &&
                        this.props.currentOrganization.integrations.some(integration => integration.type === "make") &&

                        (this.props.activityData.activityActions && 
                        Array.isArray(this.props.activityData.activityActions) &&
                        this.props.type === "activity" &&
                        this.props.activityData.activityActions.some(action => action.name === "make.com")) && 
                        (
                            <Popup
                                content='make.com'
                                className="popupStyled"
                                mouseEnterDelay={500}
                                position="top right"
                                trigger={
                                    <div className="activity-circle-icon" >
                                        <img 
                                            src={"https://res.cloudinary.com/aspenify-dev/image/upload/v1734520930/ih5xnyzus1ungzwtaohc.png"} 
                                            name="make.com" alt='make.com' 
                                            style={{ margin: "4px",borderRadius: "100%" }} 
                                        />
    
                                    </div>
                                }
                            />
                        )
                    }
                    {
                        (page === "sequence" && type === "stage" && activityData.integration && Object.keys(activityData.integration).length !==0) ?
                            <Image
                                style={{
                                    height: "20px",
                                    width:"20px"
                                    // verticalAlign: "inherit",
                                    // display: "inline",
                                }}
                                src={activityData.integration.image}
                            />
                            : null
                    }

                    
                    {!_.isEmpty(selectedPracticeLibrary) && selectedPracticeLibrary.status === 0 && type === "activity" && selectedActivity.isLeafNode ?
                        <Popup
                            content='Dependency'
                            className="popupStyled"
                            mouseEnterDelay={500}
                            position="top left"
                            inverted
                            trigger={checkDependency ?
                                <div className="activity-circle-icon " onClick={(e) => this.dependencyClick(e, activityData)}>
                                    <Icon className="dependency-color f_12" name="linkify" />
                                </div>
                                :
                                enableLinkActivity && selectedActivity._id != _id &&
                                <div className="activity-circle-icon activity-dependent" onClick={(e) => this.dependencyClick(e, activityData)}>
                                    <Icon name="linkify" className="f_12 dependency-color-default" />
                                </div>
                            } /> : null}

                  
                    {!_.isEmpty(selectedPracticeLibrary) && 
                        selectedPracticeLibrary.status !== 4 && 
                        selectedPracticeLibrary.status !== 5 &&
                        type === "activity" && 
                        (selectedActivity._id !== activityData._id || selectedActivity._id === activityId) ?
                            <div className={`activity-circle-icon pull-right activityTrash  ${selectedActivity && selectedActivity._id === activityId ? "showActivityTrash" : ""} `} >
                                <Icon name="trash alternate" className="f_12 clr-orange" onClick={e => this.removeCard(e, activityData)} />
                            </div> : null
                        }

                </div>

                <div className="activity-count-box" >
                    {type === "activity" && activityData.duration ?
                        <Popup
                            content='Days'
                            className="popupStyled"
                            mouseEnterDelay={500}
                            inverted
                            trigger={<div><Icon name="calendar alternate" /> {activityData.duration}</div>} />
                        : null}
                    {selectedPracticeLibrary.status !== 4 && selectedPracticeLibrary.status !== 5 && activityData.notes && activityData.notes.length !== 0 ?
                        <Popup
                            className="popupStyled"
                            mouseEnterDelay={500}
                            inverted
                            content='Comments'
                            position={`top ${type === "phase" ? "left" : "right"}`}
                            trigger={<div className={`${type === "phase" ? "float-left text-left" : "float-right text-right"}`} ><Icon name="comment" flipped="horizontally" /> {activityData.notes && activityData.notes.length}</div>} />
                        : null}
                    {activityData.references && activityData.references.length !== 0 ?
                        <Popup
                            content='References'
                            position={`top ${type === "phase" ? "left" : "right"}`}
                            className="popupStyled"
                            mouseEnterDelay={500}
                            inverted
                            trigger={<div className={`${type === "phase" ? "float-left text-left" : "float-right text-right"}`} ><Image style={{ height: "10px", verticalAlign: "inherit", display: "inline" }} src={contentIcon} /> <span >{activityData.references && activityData.references.length}</span></div>} />
                        : null}
                    {activityData.attachments && activityData.attachments.length !== 0 ?
                        <Popup
                            content='Attachments'
                            position={`top ${type === "phase" ? "left" : "right"}`}
                            className="popupStyled"
                            mouseEnterDelay={500}
                            inverted
                            trigger={<div className={`${type === "phase" ? "float-left text-left" : "float-right text-right"}`} ><Icon name="attach" /> {activityData.attachments && activityData.attachments.length}</div>} />
                        : null }
                </div>
            </div >
        )
    }
}

export default PlaybookActivityCard;